const links = [
  {
    name: "subscription",
    image: "subscription",
    path: "/subscription",
    isSelf: true,
    registerTicket: true,
    registerMember: true,
  },
  {
    name: "sale history",
    image: "sale",
    path: "/sale-history",
    isSelf: false,
    registerTicket: true,
    registerMember: true,
  },
  {
    name: "photo",
    image: "photo",
    path: "/photo",
    isSelf: true,
    registerTicket: true,
    registerMember: true,
  },
  {
    name: "customer info",
    image: "customer",
    path: "/customer-info",
    isSelf: true,
    registerTicket: true,
    registerMember: true,
  },
  {
    name: "password",
    image: "password",
    path: "/password",
    isSelf: false,
    registerTicket: true,
    registerMember: true,
  },
  {
    name: "register ticket",
    image: "ticket",
    path: "/register-ticket",
    isSelf: true,
    registerTicket: false,
    registerMember: true,
  },
  {
    name: "register managed",
    image: "managed",
    path: "/register-managed",
    isSelf: false,
    registerTicket: true,
    registerMember: false,
  },
];
export const getLinks = (isSelf, config, hasSubscription) => {
  return links
    .filter((link) => {
      if (!isSelf) {
        if (!link.isSelf) {
          return false;
        }
        return true;
      }
      return true;
    })
    .filter((link) => {
      if (!config.registerTicket) {
        if (!link.registerTicket) {
          return false;
        }
        return true;
      }
      return true;
    })
    .filter((link) => {
      if (!config.registerMember) {
        if (!link.registerMember) {
          return false;
        }
        return true;
      }
      return true;
    })
    .filter((link) => {
      if (!hasSubscription) {
        return link.name !== "subscription";
      }
      return true;
    });
};
